import { Button } from '@jouzen/ecom-components/v3/Button';
import { cx } from 'class-variance-authority';
import { forwardRef } from 'react';

import LandingPageHeroChicletCtaText from './LandingPageHeroChicletCtaText';
import type { LandingPageHeroChicletCtaProps } from './types';

const LandingPageHeroChicletCtaButton = forwardRef<
  HTMLButtonElement,
  LandingPageHeroChicletCtaProps
>(function LandingPageHeroChicletCtaButton({ className, label, onClick }, ref) {
  return (
    <Button
      className={cx('leading-[0px]', className)}
      data-cy="landing-page-hero-chiclet-cta"
      ref={ref}
      variant="unset"
      onClick={onClick}
    >
      <LandingPageHeroChicletCtaText label={label} />
    </Button>
  );
});

export default LandingPageHeroChicletCtaButton;
